<template>
  <div>
    <!-- Delete Confirmation Of CICLO AUTO CONTROLLO-->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="cicloautodeletedialog"
      width="unset"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1 headline">
          <v-toolbar-title class="white--text"
            >Questo elemento verrà eliminato definitivamente</v-toolbar-title
          >
        </v-toolbar>
        <v-card-text class="mt-6">
          <h3 style="text-align: left !important">
            Sei sicuro? vuoi eliminare questa elemento?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="cicloautodeletedialog = false">ANNULLA</v-btn>
          <v-btn color="green" dark @click="deletecicloAutoControllo">CONFERMA</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog In case of Many Articolo -->
    <v-dialog persistent v-model="dialog_gestione_articoli" width="800">
      <v-card>
        <v-toolbar dark color="indigo" dense>
          <v-toolbar-title>Articoli</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn small light @click="dialog_gestione_articoli = false">
            <v-icon color="red"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="max-height: 500px; overflow-y: auto">
          <v-data-table :headers="ArticoliHeaders" :items="ArticoliLista">
            <template v-slot:[`item.details`]="{ item }">
              <v-col md="4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      style="float: left"
                      @click="selectArticolo(item)"
                      small
                    >
                      <v-icon color="primary">mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Aggiungi</span>
                </v-tooltip>
              </v-col>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- MAIN CICLO AUTO CONTROLLO LISTA CARD -->
    <v-hover>
      <template v-slot="{ hover }">
        <v-card witdh="1200" :elevation="hover ? 24 : 2">
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">Ciclo Autocontrollo</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- ACition button to open a creation form for CICLO AUTO CONTROLLO -->
            <Button
              colore_icona="primary"
              idForm="QUALITA"
              idOggetto="CREA_CICLOAUTOCONTROLLO"
              mdi_icona="mdi-plus"
              testo_tooltip="Aggiungi Ciclo Autocontrollo"
              v-on:buttonClick="nuovi_ciclo_auto_controllo"
            />
            <v-spacer></v-spacer>
            <!-- ACTION BUTTON TO TURN BACK TO MENU -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="clickChiudi" small>
                  <v-icon color="error">mdi-keyboard-backspace</v-icon>
                </v-btn>
              </template>
              <span>Torna al menu</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center">
              <v-col class="py-0" cols="2" md="1"></v-col>
              <v-col class="py-0" cols="4" md="6">
                <v-text-field
                  v-model="cod_articolo"
                  label="Cod. Articolo"
                  placeholder="Cod. Articolo"
                  v-on:keydown.enter.prevent="searchArticolo"
                >
                </v-text-field>
              </v-col>
              <v-col class="py-0" cols="2" md="2">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="searchArticolo"
                      v-bind="attrs"
                      v-on="on"
                      small
                      style="top: 20px; right: 50px"
                      ><v-icon color="primary">mdi-magnify</v-icon></v-btn
                    >
                  </template>
                  <span>Cerca</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="12">
                <v-data-table
                  :headers="headers_ciclo_auto_contorollo"
                  :items="items_ciclo_auto_contorollo"
                >
                  <!--Action Button to show the detail of select
                  ed CIclo auto controllo -->
                  <template v-slot:[`item.detail`]="{ item }">
                    <Button
                      colore_icona="primary"
                      idForm="QUALITA"
                      idOggetto="MODIFICA_CICLOAUTOCONTROLLO"
                      mdi_icona="mdi-pencil"
                      testo_tooltip="Dettaglio Ciclo Autocontrollo"
                      v-on:buttonClick="dettaglio_ciclo_auto_conrtrollo(item)"
                    />
                  </template>
                  <!-- Button to delete single Ciclo Auto Controllo -->
                  <template v-slot:[`item.delete`]="{ item }">
                    <Button
                      colore_icona="error"
                      idForm="QUALITA"
                      idOggetto="ELIMINA_CICLOAUTOCONTROLLO"
                      mdi_icona="mdi-window-close"
                      testo_tooltip="Cancellare"
                      v-on:buttonClick="
                        confermaDelCicloAutoConytollo = true;
                        setitem(item);
                      "
                    />
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </v-hover>
    <!-- Snackbar in order to show the result -->
    <v-snackbar :color="color" content-class="snackbar" right v-model="snackbar">
      <v-icon :size="64">{{ mainIcon }}</v-icon>
      <h2 class="mt-n8 ml-16">{{ snackbar_text }}</h2>
      <template v-slot:action="{ attrs }">
        <v-btn
          fab
          dark
          style="margin-top: -6rem"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Button from "@/components/TOOLS/FormComponentPermissions/Button.vue";
export default {
  components: { Button },
  data() {
    return {
      // Overlay variable
      overlay: false,
      // Deletion Dialog of Ciclo autocontrollo
      cicloautodeletedialog: false,
      selectedCiclo: {},
      //Main Icon for SnackBar
      mainIcon: "",
      color: "",
      snackbar: false,
      snackbar_text: "",
      // Dialog Variable for list of articolo
      dialog_gestione_articoli: false,
      // VARIABLE for TEXT INPUT FIELDS
      cod_articolo: null,
      des_fase: "",
      // Header of the TABLE
      headers_ciclo_auto_contorollo: [],
      // Items LIst for the table
      items_ciclo_auto_contorollo: [],
      // DATA TABLE HEADER
      ArticoliHeaders: [
        {
          text: "",
          value: "details",
          sortable: false,
        },
        {
          text: "Cod Articolo",
          value: "cod_articolo",
          sortable: false,
        },
        {
          text: "Des Articolo",
          value: "des_articolo",
          sortable: false,
        },
        {
          text: "Famiglia",
          value: "id_famiglia",
          sortable: false,
        },
        {
          text: "Tipo",
          value: "id_tipo",
          sortable: false,
        },
        {
          text: "Tipo Fornitura",
          value: "id_tipo_fornitura",
          sortable: false,
        },
      ],
      // DATA LISTA
      ArticoliLista: [],
    };
  },
  methods: {
    // IN order to show the delete dialog
    setitem(item) {
      this.selectedCiclo = item;
      this.cicloautodeletedialog = true;
    },
    // In order to Get the Detail of Articolo from dialog of Articoli
    selectArticolo(item) {
      this.cod_articolo = item.cod_articolo;
      this.id_articolo = item.id_articolo;
      this.getCicloAutoControllo();
      this.overlay = false;
      this.dialog_gestione_articoli = false;
    },
    // In orderto Directly Search the Articolo
    searchArticolo() {
      this.overlay = true;
      let search_Articolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.cod_articolo,
        },
      };
      // Eseguo la chiamata al BE
      this.$store.dispatch("api", search_Articolo).then((res) => {
        if (res.data.lista.length == 0) {
          this.snackbar = true;
          this.snackbar_text = "L'articolo non è stato trovato. Riprova !";
          this.mainIcon = "mdi-close-circle";
          this.color = "red accent-4";
          this.loadingVal = false;
          this.progressBar = false;
          this.overlay = false;
          this.savebutton = false;
          this.topDiv = true;
        }
        if (res.data.lista.length > 1) {
          this.overlay = false;
          this.dialog_gestione_articoli = true;
          this.ArticoliLista = res.data.lista;
        }
        if (res.data.lista.length == 1) {
          this.overlay = false;
          this.id_articolo = res.data.lista[0].id_articolo;
          //console.log("Id_articolo cicloautocontrollo: ", this.id_articolo);
          this.cod_articolo = res.data.lista[0].cod_articolo;
          // Triggering function to get list of cicloautocontrollo
          this.getCicloAutoControllo();
          // Getting Ciclo lista to populate the table
        }
      });
    },
    // GetCicloautoControlo
    getCicloAutoControllo() {
      let getCicloAutoControllo = {
        controller: "qualita",
        method: "POST",
        richiesta: {
          action: "getcicloautocontrollo",
          token: localStorage.user_token,
          id_ciclo_autocontrollo: "",
          id_articolo: this.id_articolo,
        },
      };
      this.$store.dispatch("api", getCicloAutoControllo).then((res) => {
        if (res.data.lista.length == 0) {
          this.snackbar = true;
          this.items_ciclo_auto_contorollo = [];
          this.snackbar_text = "Non esiste un ciclo autocontrollo per questo articolo.";
          this.mainIcon = "mdi-close-circle";
          this.color = "red accent-4";
        }
        if (res.data.lista.length > 1) {
          this.headers_ciclo_auto_contorollo = res.data.header;
          /* Aggiungo l'header per la modifica. */
          let edit = {
            value: "detail",
            sortable: false,
          };
          this.headers_ciclo_auto_contorollo.unshift(edit);
          /* Aggiungo l'header per la cancellazione. */
          let del = {
            value: "delete",
            sortable: false,
          };
          this.headers_ciclo_auto_contorollo.push(del);
          this.items_ciclo_auto_contorollo = res.data.lista;
        }
        if (res.data.lista.length == 1) {
          this.dettaglio_ciclo_auto_conrtrollo(res.data.lista[0]);
        }
      });
    },
    // In order to Remove single ciclo auto  controllo
    deletecicloAutoControllo() {
      this.overlay = true;
      this.selectedCiclo.validita = 0;
      let setPianoControllo = {
        controller: "qualita",
        method: "PUT",
        richiesta: {
          action: "setcicloautocontrollo",
          token: localStorage.user_token,
          qm_ciclo_autocontrollo: [this.selectedCiclo],
          id_ciclo_autocontrollo: this.selectedCiclo.id_ciclo_autocontrollo,
        },
      };
      this.$store.dispatch("api", setPianoControllo).then(() => {
        this.overlay = false;
        let i = this.items_ciclo_auto_contorollo.findIndex(
          (it) => it == this.selectedCiclo
        );
        this.items_ciclo_auto_contorollo.splice(i, 1);
        this.snackbar = true;
        this.snackbar_text = "Modifica effettuata con successo!";
        this.color = "green darken-3";
        this.mainIcon = "mdi-check-circle";
        this.selectedCiclo = {};
        this.cicloautodeletedialog = false;
      });
    },
    // Function to get us back to Main menu
    clickChiudi() {
      this.id_articolo = "";
      this.cod_articolo = "";
      this.items_ciclo_auto_contorollo = [];
      this.$route.params.id = null;
      this.$emit("click_chiudi");
    },
    // Function trigger with PLus button in order to navigate to Creation Form
    nuovi_ciclo_auto_controllo() {
      this.$router.push({
        name: "CicloAutoControlloDetail",
        params: {
          foo: -1,
        },
      });
    },
    // Function trigger with Pencil button in order to navigate to Detail page
    dettaglio_ciclo_auto_conrtrollo(item) {
      console.log("Da cicloautocontrollo: ", item);
      this.$router.push({
        name: "CicloAutoControlloDetail",
        params: {
          foo: item.id_ciclo_autocontrollo,
          id_articolo: this.id_articolo,
        },
      });
    },
  },
  mounted() {
    // IN order to Populate the table after Saving or creating Ciclo AutoControllo
    if (this.$route.params.id > 0) {
      this.overlay = true;
      let getCicloAutoControllo = {
        controller: "qualita",
        method: "POST",
        richiesta: {
          action: "getcicloautocontrollo",
          token: localStorage.user_token,
          id_ciclo_autocontrollo: "",
          id_articolo: this.$route.params.id,
        },
      };
      this.$store.dispatch("api", getCicloAutoControllo).then((res) => {
        this.overlay = false;
        if (res.data.lista.length == 0) {
          this.snackbar = true;
          this.snackbar_text = "Non esiste un ciclo autocontrollo per questo articolo.";
          this.mainIcon = "mdi-close-circle";
          this.color = "red accent-4";
        }
        this.headers_ciclo_auto_contorollo = res.data.header;
        /* Aggiungo l'header per la modifica. */
        let edit = {
          value: "detail",
          sortable: false,
        };
        this.headers_ciclo_auto_contorollo.unshift(edit);
        /* Aggiungo l'header per la cancellazione. */
        let del = {
          value: "delete",
          sortable: false,
        };
        this.headers_ciclo_auto_contorollo.push(del);
        this.items_ciclo_auto_contorollo = res.data.lista;
        this.dialog_gestione_articoli = false;
      });
    }
  },
};
</script>
